export enum AnalyticsRoutes {
  root = 'analytics',
  overall = 'overall',
  conversations = 'conversations',
  messages = 'messages',
  calls = 'calls',
  performance = 'performance',
  contacts = 'contacts',
  conversions = 'conversions',
  creditUsage = 'credit-usage',
}
